import angular from 'angular';

import fileUploadComponent from './file-upload.component';
import FileUpload from './file-upload.directive';
import LoadedModel from '../services/loaded-model';

let fileUploadModule = angular.module('base', [])

.component('fileUpload', fileUploadComponent)
.directive('fileUpload', FileUpload)
.service('LoadedModel', LoadedModel)
.name;

export default fileUploadModule;



// WEBPACK FOOTER //
// ./client/app/common/file-upload/file-upload.js